import { Reveal } from '../shared/reveal/reveal';

const GROUPS: { label: string; items: string[] }[] = [
  { label: 'languages', items: ['TypeScript', 'JavaScript', 'C# / .NET', 'SQL', 'HTML / CSS'] },
  {
    label: 'frameworks',
    items: ['React', 'Next.js', 'Angular', 'Razor', 'Node.js', 'Vite', 'Serverless'],
  },
  {
    label: 'cloud & infra',
    items: [
      'AWS',
      'Azure',
      'Terraform',
      'Docker',
      'GitHub Actions',
      'Lambda',
      'API Gateway',
      'DynamoDB',
      'RDS',
      'CloudFront',
      'S3',
      'SQS',
      'ECS',
    ],
  },
];

export function Skills() {
  return (
    <section id="skills" className="mx-auto max-w-content px-5 py-16">
      <Reveal>
        <p className="section-kicker">{'// 02 — stack'}</p>
        <h2 className="mt-2 font-mono text-2xl font-bold tracking-tight text-fg sm:text-3xl">
          Tech stack
        </h2>
      </Reveal>

      <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-3">
        {GROUPS.map((group, i) => (
          <Reveal key={group.label} delay={i * 90}>
            <div className="terminal-card h-full p-5">
              <p className="font-mono text-sm text-accent">{group.label}</p>
              <div className="mt-4 flex flex-wrap gap-2">
                {group.items.map((item) => (
                  <span key={item} className="tag">
                    {item}
                  </span>
                ))}
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
